import React from "react";
import { Typography, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";

const ImageUploadButton = ({ uploading, onUpload, label }) => {
    return (
        <div style={{ marginTop: "1vh", marginBottom: "1vh" }}>
            <Typography
                variant="h6"
                onClick={uploading ? undefined : onUpload}
                style={{
                    cursor: uploading ? 'default' : 'pointer',
                    width: '100%',
                    textAlignLast: 'center',
                    padding: '2%',
                    borderRadius: '1vh',
                    fontSize: '1.6vh',
                    opacity: uploading ? 0.7 : 1,
                    minHeight: '4vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                className="schedule-btn"
            >
                {uploading ? (
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress size="2vh" style={{ color: 'white' }} />
                    </span>
                ) : label}
            </Typography>
        </div>
    );
};

ImageUploadButton.propTypes = {
    uploading: PropTypes.bool.isRequired,
    onUpload: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};

export default ImageUploadButton;
